import { SsoState } from '@common/neo.tax';

import { env, getFilteredQueryParams, getPathUrl, Path } from '@neo.tax/shared/utils';

export const redirectToGoogleOAuth = (): void => {
  window.location.href = getGoogleOAuthRedirectUrl();
};

const getGoogleSsoBackEndRedirectUrl = (): string =>
  `${env.REACT_APP_BACKEND_BASE_URL}/third-party-tokens/google/callback`;

const getGoogleOAuthRedirectUrl = (): string => {
  const existingQueryParams = getFilteredQueryParams().toString();
  const ssoState: SsoState = {
    existingQueryParams,
    successRedirectUrl: getPathUrl({ path: Path.LOGIN }),
    errorRedirectUrl: getPathUrl({ path: Path.LOGIN }),
  };

  const params = {
    client_id: env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
    redirect_uri: getGoogleSsoBackEndRedirectUrl(),
    response_type: 'code',
    scope: 'profile email', // space delimited
    include_granted_scopes: 'true',
    state: JSON.stringify(ssoState),
  };

  const googleRedirectUrl = new URL(env.REACT_APP_GOOGLE_OAUTH_ENDPOINT);
  Object.entries(params).forEach(([key, value]) => googleRedirectUrl.searchParams.append(key, value));

  return googleRedirectUrl.toString();
};
